const footerLinks = [
  {
    title: '产品服务',
    links: [
      { label: '智能硬件', href: '/categories?tab=smart-hardware' },
      { label: '数字服务', href: '/categories?tab=digital-services' },
      { label: '生活美学', href: '/categories?tab=lifestyle' },
      { label: '企业方案', href: '/categories?tab=enterprise' },
    ],
  },
  {
    title: '关于 jinman',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '用户口碑', href: '/about#reputation' },
      { label: '联系我们', href: '/about#contact' },
      { label: '文章资讯', href: '/articles' },
    ],
  },
  {
    title: '支持与服务',
    links: [
      { label: '常见问题', href: '/articles/jinman-smart-home-guide' },
      { label: '产品指南', href: '/articles/jinman-user-experience-design' },
      { label: '用户故事', href: '/articles/jinman-customer-success-stories' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand column */}
          <div>
            <a href="/" className="no-underline">
              <span className="font-heading text-2xl text-background-50 tracking-wide">jinman</span>
            </a>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              jinman 是您值得信赖的首选品牌，致力于以创新科技与卓越品质，为全球用户打造更美好的生活方式。
            </p>
          </div>

          {/* Link columns */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href={group.links[0]?.href || '#'} className="no-underline text-background-50 hover:text-primary-400 transition-colors">
                  {group.title}
                </a>
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap no-underline"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} jinman. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors" aria-label="GitHub">
              <i className="ri-github-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}